import {
  Button,
  DatePicker,
  Drawer,
  Input,
  Select,
  Space,
  Typography,
  message,
} from 'antd';
import CustomSelect from '../../common/Select/Select';
import { initFilters } from './Payouts';
import { useContext, useState } from 'react';
import { getCountryEmail } from '../../../services/commonAPI';
import { dateRange } from '../../../utils/helpers/helper';
import { CountryContext } from '../../common/Navigation/Navigation';

const dateOptions = [
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    label: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    label: 'This month',
    value: 'This month',
  },
  {
    label: 'Last month',
    value: 'Last month',
  },
  {
    label: 'Custom',
    value: 'Custom',
  },
];

// const currentYear = new Date().getFullYear();
// const startYear = 1990;
// const yearOptions = [];

// for (let year = currentYear; year >= startYear; year--) {
//   yearOptions.push({ key: year.toString(), value: year.toString() });
// }

export default function FiltersPane({
  openFilters,
  setOpenFilters,
  filterValues,
  setFilterValues,
  handleApply,
}) {
  const { Text } = Typography;
  let currentValue = {
    contributorEmail: '',
  };

  const [options, setOptions] = useState({
    contributorEmail: [],
  });
  const [error, setError] = useState({
    contributorEmail: '',
  });
  const [loader, setLoader] = useState({
    contributorEmail: false,
  });
  let api = { contributorEmail: '/email' };

  const { countries } = useContext(CountryContext);

  // List of filters
  const filters = [
    {
      name: 'Contributor',
      key: 'contributorEmail',
      // type: 'api',
      type: 'text',
      mode: 'multiple',
      value: filterValues['contributorEmail'] || '',
      placeholder: 'Enter contributor email address',
      info: 'please enter 3 letters to search',
    },
    {
      name: 'Contributor Country',
      key: 'country',
      mode: 'multiple',
      type: 'select',
      options: countries,
    },
    {
      name: 'Created Date',
      key: 'fixedRangeForCreated',
      defaultValue: 'Last 30 days',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'fixedRangeForCreated')
            }
            options={dateOptions}
            value={filterValues['fixedRangeForCreated'] || 'Last 30 days'}
            defaultValue={
              filterValues['fixedRangeForCreated'] || 'Last 30 days'
            }
          />
          {filterValues.fixedRangeForCreated === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={
                (filterValues['fixedRangeForCreated.customDates'] &&
                  dateRange(
                    filterValues['fixedRangeForCreated.customDates'],
                  )) ||
                ''
              }
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'fixedRangeForCreated.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Payout Closed',
      key: 'fixedRangeForCompleted',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'fixedRangeForCompleted')
            }
            options={dateOptions}
            value={filterValues['fixedRangeForCompleted']}
            placeholder="Select Range"
            defaultValue={filterValues['fixedRangeForCompleted']}
          />
          {filterValues.fixedRangeForCompleted === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={
                (filterValues['fixedRangeForCompleted.customDates'] &&
                  dateRange(
                    filterValues['fixedRangeForCompleted.customDates'],
                  )) ||
                ''
              }
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'fixedRangeForCompleted.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Voided Date',
      key: 'fixedRangeForVoided',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'fixedRangeForVoided')
            }
            options={dateOptions}
            placeholder="Select Range"
            value={filterValues['fixedRangeForVoided']}
            defaultValue={filterValues['fixedRangeForVoided']}
          />
          {filterValues.fixedRangeForVoided === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={
                (filterValues['fixedRangeForVoided.customDates'] &&
                  dateRange(filterValues['fixedRangeForVoided.customDates'])) ||
                ''
              }
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'fixedRangeForVoided.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Payout Rail',
      key: 'payoutRail',
      mode: 'multiple',
      type: 'select',
      placeholder: 'Select payout Rail',
      options: [
        {
          key: 'ach',
          value: 'ach',
        },
        {
          key: 'airtm',
          value: 'airtm',
        },
        {
          key: 'cash_app',
          value: 'cash_app',
        },
        {
          key: 'intl_bank',
          value: 'intl_bank',
        },
        {
          key: 'payoneer',
          value: 'payoneer',
        },
        {
          key: 'paypal',
          value: 'paypal',
        },
        {
          key: 'venmo',
          value: 'venmo',
        },
      ],
    },
    {
      name: 'Default Rail Changed',
      key: 'defaultRail',
      type: 'select',
      options: [
        {
          key: 'Null',
          value: 'Null',
        },
        {
          key: 'True',
          value: 'True',
        },
        {
          key: 'False',
          value: 'False',
        },
      ],
    },
    // {
    //   name: 'Payout Period',
    //   key: 'payoutPeriod',
    //   type: 'custom',
    //   renderer: () => (
    //     <div style={{ display: 'flex', gap: 16 }}>
    //       <Select
    //         style={{ flex: 1 }}
    //         value={filterValues['payoutPeriod.month']}
    //         mode="multiple"
    //         placeholder="Enter month"
    //         onChange={(e) =>
    //           handleFilterChange(e, 'select', 'payoutPeriod.month')
    //         }
    //         options={[
    //           { key: 'January', value: 'January' },
    //           { Key: 'February', value: 'February' },
    //           { key: 'March', value: 'March' },
    //           { key: 'April', value: 'April' },
    //           { key: 'May', value: 'May' },
    //           { key: 'June', value: 'June' },
    //           { key: 'July', value: 'July' },
    //           { key: 'August', value: 'August' },
    //           { key: 'September', value: 'September' },
    //           { key: 'October', value: 'October' },
    //           { key: 'November', value: 'November' },
    //           { key: 'December', value: 'December' },
    //         ]}
    //       />
    //       <Select
    //         style={{ flex: 1 }}
    //         value={filterValues['payoutPeriod.year']}
    //         placeholder="Enter Year"
    //         onChange={(e) =>
    //           handleFilterChange(e, 'select', 'payoutPeriod.year')
    //         }
    //         options={yearOptions || []}
    //       />
    //     </div>
    //   ),
    // },
    {
      name: 'Payout Status',
      key: 'status',
      type: 'select',
      mode: 'multiple',
      placeholder: 'Select payout status',
      options: [
        {
          key: 'Ready for Finance Review',
          value: 'Ready for Finance Review',
        },
        {
          key: 'Under Further Review',
          value: 'Under Further Review',
        },
        {
          key: 'Ready to Remit',
          value: 'Ready to Remit',
        },
        {
          key: 'Payout Initiated',
          value: 'Payout Initiated',
        },
        {
          key: 'Payout Pending',
          value: 'Payout Pending',
        },
        {
          key: 'Payout Failure',
          value: 'Payout Failure',
        },
        {
          key: 'Payout Completed',
          value: 'Payout Completed',
        },
        {
          key: 'Voided',
          value: 'Voided',
        },
        {
          key: 'Regenerated',
          value: 'Regenerated',
        },
      ],
    },
    {
      name: 'Reattempted',
      key: 'reattempted',
      type: 'select',
      defaultValue: filterValues['reattempted'],
      options: [
        {
          label: 'All',
          value: '',
        },
        {
          label: 'False',
          value: false,
        },
        {
          label: 'True',
          value: true,
        },
      ],
    },
    {
      name: 'Attempt',
      key: 'reattemptStatus',
      type: 'select',
      mode: 'multiple',
      options: [
        {
          key: 'Pending Reattempt',
          value: 'Pending Reattempt',
        },
        {
          key: 'Reattempt Failed',
          value: 'Reattempt Failed',
        },
        {
          key: 'Reattempt Successful',
          value: 'Reattempt Successful',
        },
      ],
    },
    {
      name: 'Notes',
      key: 'notes',
      type: 'custom',
      renderer: () => (
        <div style={{ display: 'flex', gap: 16 }}>
          <Select
            style={{ flex: 1 }}
            defaultValue={'Contains'}
            value={filterValues['notes.type'] || 'Contains'}
            onChange={(e) => handleFilterChange(e, 'select', 'notes.type')}
            options={[
              { key: 'Contains', value: 'Contains' },
              { key: 'Does not contain', value: 'Does not contain' },
            ]}
          />
          <Input
            value={filterValues['notes.value'] || ''}
            placeholder="Enter Notes"
            onChange={(e) =>
              handleFilterChange(e.target.value, 'text', 'notes.value')
            }
            style={{ flex: 1 }}
          />
        </div>
      ),
    },
    {
      name: 'Failure Reason',
      key: 'failureNotes',
      type: 'custom',
      renderer: () => (
        <div style={{ display: 'flex', gap: 16 }}>
          <Select
            style={{ flex: 1 }}
            defaultValue={'Contains'}
            value={filterValues['failureNotes.type'] || 'Contains'}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'failureNotes.type')
            }
            options={[
              { key: 'Contains', value: 'Contains' },
              { key: 'Does not contain', value: 'Does not contain' },
            ]}
          />
          <Input
            value={filterValues['failureNotes.value'] || ''}
            placeholder="Enter Failed Reason"
            onChange={(e) =>
              handleFilterChange(e.target.value, 'text', 'failureNotes.value')
            }
            style={{ flex: 1 }}
          />
        </div>
      ),
    },
  ];

  const handleReset = () => {
    setFilterValues(initFilters);
  };

  const handleFilterChange = (v, _type, key) => {
    setFilterValues({
      ...filterValues,
      [key]: v,
    });
  };

  const handleFilterSearch = (v, _type, key) => {
    currentValue[key] = v;
    if (v.length > 2) {
      setLoader({ ...loader, [key]: true });
      getCountryEmail({ value: v, uri: api[key] })
        .then((res) => {
          if (currentValue[key] === v) {
            const data = res.map((ele) => ({
              key: ele,
              value: ele,
            }));
            if (data.length === 0) {
              setError({ ...error, [key]: `No data found with ${v}` });
            }
            setOptions({ ...options, [key]: data });
          }
        })
        .catch(() => {
          setError({ ...error, [key]: `Unable to fetch ${key}` });
        })
        .finally(() => {
          setLoader({ ...loader, [key]: false });
        });
    } else {
      setError({ ...error, [key]: '' });
    }
  };

  return (
    <Drawer
      title={`Filters`}
      placement="right"
      size={400}
      onClose={() => setOpenFilters(false)}
      open={openFilters}
      extra={
        <Space>
          <Button onClick={() => handleReset()}>Reset</Button>
          <Button type="primary" onClick={() => handleApply()}>
            Apply
          </Button>
        </Space>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {filters.map((filter) => {
          return (
            <div key={filter.name} style={{ display: 'block' }}>
              <Text key={filter.name} style={{ fontSize: '16px' }}>
                {filter.name}
              </Text>
              {filter.type === 'text' ? (
                <Input
                  key={filter.name}
                  placeholder={filter.name}
                  defaultValue={filter.defaultValue}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) =>
                    handleFilterChange(e.target.value, 'text', filter.key)
                  }
                />
              ) : filter.type == 'select' ? (
                <CustomSelect
                  mode={filter.mode}
                  key={filter.name}
                  disabled={filter.disabled}
                  options={filter.options || []}
                  defaultValue={filterValues[filter.key] || filter.defaultValue}
                  placeholder={filter.name}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) => handleFilterChange(e, 'select', filter.key)}
                />
              ) : filter.type == 'api' ? (
                <CustomSelect
                  loading={loader[filter.key]}
                  mode={filter.mode}
                  key={filter.name}
                  disabled={filter.disabled}
                  notFoundContent={error[filter.key] || filter.info}
                  options={options[filter.key] || []}
                  defaultValue={filterValues[filter.key] || filter.defaultValue}
                  placeholder={filter.placeholder}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onSearch={(e) => handleFilterSearch(e, 'select', filter.key)}
                  onChange={(e) => handleFilterChange(e, 'select', filter.key)}
                />
              ) : filter.type == 'custom' ? (
                filter.renderer()
              ) : null}
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
